import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'How does TenderAI work?',
    answer:
      'Upload your tender documentation and TenderAI analyzes the full document set, extracting key requirements, eligibility criteria, and compliance conditions. The platform maps these requirements against your inputs, highlights potential risks, and generates a structured compliance matrix to support your application preparation.',
  },
  {
    question: 'What types of tenders does TenderAI support?',
    answer:
      'TenderAI supports all government and private sector tenders across industries including infrastructure, healthcare, IT services, construction, and professional services. Whether it is a Request for Proposal (RFP), Request for Tender (RFT), or Expression of Interest (EOI), our platform handles complex multi-stage procurement processes.',
  },
  {
    question: <>How long does it take to review<br className="md:hidden" /> a tender?</>,
    answer:
      'Initial document analysis and compliance mapping typically take 5–15 minutes, depending on the size and complexity of the tender. The platform can process documents exceeding 200 pages, automatically extracting requirements and evaluation criteria.\n\nGenerating a structured compliance matrix and draft application typically takes within a few hours depending on the complexity of the tender and the amount of supporting information provided.',
  },
  {
    question: 'Is my tender data secure and confidential?',
    answer:
      'Absolutely. All documents are encrypted in transit and at rest using bank-grade AES-256 encryption. We are ISO 27001 certified and fully GDPR compliant. Your tender data is never used to train our models, and you maintain complete ownership. Data is automatically purged based on your retention policies.',
  },
  {
    question: <>Do I still need a team to review<br className="md:hidden" /> the tender?</>,
    answer:
      'Yes. TenderAI assists teams in analyzing tender requirements and organizing the information needed for a submission. The platform structures key conditions, highlights potential risks, and maps compliance criteria so teams can prepare applications more efficiently and with greater clarity.',
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-spacing scroll-mt-24"
    >
      <div className="section-container">
        <div className="max-w-3xl mx-auto">
          <h2
            data-animate
            className="font-display text-2xl sm:text-3xl lg:text-[2.5rem] tracking-[-0.01em] leading-[1] lg:leading-[1.1] text-center mb-12"
          >
            Frequently Asked Questions
          </h2>

          <Accordion
            type="single"
            collapsible
            className="space-y-4"
            data-animate
            style={{ transitionDelay: '100ms' }}
          >
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                data-testid={`faq-item-${index}`}
                className="border border-border/60 rounded-xl px-6 bg-card/50 backdrop-blur-sm"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${index}`}
                  className="text-left text-base sm:text-lg font-medium hover:no-underline py-5"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${index}`}
                  className="text-muted-foreground leading-relaxed pb-5"
                >
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
